import { Checkbox } from "antd";
import { useIntl } from "react-intl";
import { useDataTableEditableColumn } from "~components/DataTable/hooks/useDataTableEditableColumn.ts";

type Props = {
  value?: boolean | null;
  isEditMode?: boolean;
  disabled?: boolean;
  onSave?: (value: boolean) => void | Promise<void>;
};

const getInitialValue = (value?: boolean | null) => !!value;
const isEmpty = () => false;

export const DataTableBooleanColumn = ({ value, isEditMode = false, disabled = false, onSave }: Props) => {
  const { formatMessage } = useIntl();
  const { inputValue, loading, handleSave } = useDataTableEditableColumn({
    value,
    onSave,
    isEmpty,
    getInitialValue,
  });

  if (!isEditMode) {
    if (value === null || value === undefined) {
      return "";
    }
    return value ? formatMessage({ id: "yes" }) : formatMessage({ id: "no" });
  }

  return <Checkbox disabled={disabled || loading} checked={inputValue} onChange={(event) => void handleSave(event.target.checked)} />;
};
